import { render, staticRenderFns } from "./ui-breadcrumbs-detail.vue?vue&type=template&id=dae9f23c&scoped=true&"
import script from "./ui-breadcrumbs-detail.vue?vue&type=script&lang=js&"
export * from "./ui-breadcrumbs-detail.vue?vue&type=script&lang=js&"
import style0 from "./ui-breadcrumbs-detail.vue?vue&type=style&index=0&id=dae9f23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae9f23c",
  null
  
)

export default component.exports